<template>
  <div class="stats">
    <div v-if="loading" class="loading">
      <img src="../assets/images/loading5.gif" />
    </div>
    <div class="statistiques">
      <div class="lf">
        <div v-if="gameData.type == 'ODR'">
          <h2>Pages</h2>
          <select @change="onChange($event)">
            <option value="2">Généralité</option>
            <option value="3">Segmentation produit</option>
            <option value="4">Segmentation géographique</option>
            <option value="5">Rapport sur l'opération</option>
          </select>
        </div>
        <h2>Période</h2>
        <date-range-picker
          ref="picker"
          @update="updateDates"
          :autoApply="autoApply"
          :minDate="minDate"
          :maxDate="maxDate"
          :locale-data="locale"
          v-model="dateRange"
          :ranges="showranges"
          :opens="opens"
        >
          <template v-slot:input="picker" style="min-width: 350px;">
            Du {{ picker.startDate | date }} au {{ picker.endDate | date }}
          </template>
        </date-range-picker>
        <br />
        <br />
        <br />
        <GlobalResults
          v-if="page == 1"
          :chartDatas="globalDatas"
        ></GlobalResults>
        <GlobalResultsOdr
          v-if="page == 2 || page == 3"
          :page="page"
          :chartDatas="globalDatas"
        ></GlobalResultsOdr>
      </div>

      <div class="rd">
        <br />
        <br />
        <div class="logo">
          <img v-if="logo1" width="10%" :src="logo1.uri" />
          <img v-if="logo2" width="10%" :src="logo2.uri" />
        </div>
        <h1>
          Opération : <b>{{ gameData.title }}</b>
        </h1>
        <br />
        <ChartsBarsParticipants
          v-if="page == 1"
          v-bind:chartDatas="globalDatas"
        ></ChartsBarsParticipants>

        <ChartsBarsVentes
          @changeDate="changeDate"
          v-if="page == 2"
          v-bind:chartDatas="globalDatas"
        ></ChartsBarsVentes>
        <ChartsPieArticles
          @changeArticle="changeArticle"
          v-if="page == 3"
          v-bind:chartDatas="globalDatas"
        ></ChartsPieArticles>
        <ChartsGeo v-if="page == 4" v-bind:chartDatas="globalDatas"></ChartsGeo>
        <MultiSelectArticles
          v-if="page == 5"
          v-bind:chartDatas="globalDatas"
        ></MultiSelectArticles>
      </div>

      <div class="cell"><hr /></div>
      <div
        class="cell"
        style="display:flex; justify-content: space-between;text-align:center;"
      >
        <PieChartsGenders
          style="width:30%;padding-right:5%;"
          v-if="page == 1"
          v-bind:chartDatas="globalDatas"
        ></PieChartsGenders>
        <ChartsBarsLots
          style="width:60%"
          class="rd"
          v-if="page == 1"
          v-bind:chartDatas="globalDatas"
        ></ChartsBarsLots>
        <PieChartsGenders
          style="width:49%;"
          v-if="page == 3"
          v-bind:chartDatas="globalDatas"
        ></PieChartsGenders>
        <ChartsUknow
          style="width:40%;"
          v-if="page == 4"
          v-bind:chartDatas="globalDatas"
        ></ChartsUknow>
        <ChartsPieEnseignes
          style="width:49%;"
          v-if="page == 3 || page == 4"
          v-bind:chartDatas="globalDatas"
        ></ChartsPieEnseignes>
        <ChartsPieValid
          style="width:40%;"
          v-if="page == 5"
          v-bind:chartDatas="globalDatas"
        ></ChartsPieValid>
        <ChartsBarsConformite
          style="width:60%;"
          v-if="page == 5"
          v-bind:chartDatas="globalDatas"
        ></ChartsBarsConformite>
      </div>
      <div class="cell">
        <ChartsBarsCa
          v-if="page == 2"
          v-bind:chartDatas="globalDatas"
        ></ChartsBarsCa>
        <ChartsArticles
          v-if="page == 2"
          @changeArticle="changeArticle"
          v-bind:chartDatas="globalDatas"
        ></ChartsArticles>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Vue from "vue";

import GlobalResults from "@/components/graphs/globalResults";
import GlobalResultsOdr from "@/components/graphs/globalResultsOdr";
import ChartsBarsParticipants from "@/components/graphs/ChartsBarsParticipants";
import PieChartsGenders from "@/components/graphs/PieChartsGenders";
import ChartsBarsLots from "@/components/graphs/ChartsBarsLots";
import ChartsBarsVentes from "@/components/graphs/ChartsBarsVentes";
import ChartsBarsCa from "@/components/graphs/ChartsBarsCa";
import ChartsArticles from "@/components/graphs/ChartsArticles";
import ChartsPieArticles from "@/components/graphs/ChartsPieArticles";
import ChartsPieEnseignes from "@/components/graphs/ChartsPieEnseignes";
import ChartsUknow from "@/components/graphs/ChartsUknow";
import ChartsGeo from "@/components/graphs/ChartsGeo";
import ChartsParticipationsValid from "@/components/graphs/ChartsParticipationsValid";
import ChartsPieValid from "@/components/graphs/ChartsPieValid";
import ChartsBarsConformite from "@/components/graphs/ChartsBarsConformite";
import MultiSelectArticles from "@/components/graphs/MultiSelectArticles";

var moment = require("moment");

Vue.filter("date", function(value) {
  if (value) {
    return moment(value.toISOString()).format("DD MMM YYYY");
  }
});

export default {
  name: "Statistiques",
  components: {
    GChart,
    DateRangePicker,
    GlobalResults,
    GlobalResultsOdr,
    ChartsBarsParticipants,
    PieChartsGenders,
    ChartsBarsLots,
    ChartsBarsVentes,
    ChartsBarsCa,
    ChartsArticles,
    ChartsPieArticles,
    ChartsPieEnseignes,
    ChartsUknow,
    ChartsGeo,
    ChartsParticipationsValid,
    ChartsPieValid,
    ChartsBarsConformite,
    MultiSelectArticles,
  },
  data: function() {
    return {
      articleSelected: false,
      dateSelected: false,
      loading: false,
      chartsBarsLots: {},
      pieGendersCharts: {},
      chartsBar: {},
      globalDatas: {},
      page: 1,
      gameData: [],
      minDate: undefined,
      maxDate: undefined,
      logo1: {},
      logo2: {},
      opens: "right",
      autoApply: true,
      showranges: false,
      dateRange: undefined,
      customRangeLabel: "Custom Range",
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.monthsShort(),
      firstDay: moment.localeData().firstDayOfWeek(),
      locale: {
        direction: "ltr",
        format: "DD-MM-YYYY",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 1,
      },
      dateRange: {
        startDate: moment().startOf("month"),
        endDate: moment().endOf("day"),
      },
    };
  },
  methods: {
    changeDate(data) {
      if (data && data != undefined && data != "") {
        this.articleSelected = false;
        var dateObj = new Date(data);
        this.dateSelected = moment(dateObj).format("YYYY-MM-DD");
        this.updateStats();
      }
    },
    changeArticle(data) {
      if (data && data != undefined && data != "") {
        this.dateSelected = false;
        this.articleSelected = data;
        this.updateStats();
      }
    },
    changeArticlePie(data) {
      console.log(data);
    },
    updateDates(dates) {
      this.dateSelected = false; // Reset select one date
      this.articleSelected = false; // Reset select one article
      this.dateRange.startDate = moment(dates.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(dates.endDate).format("YYYY-MM-DD");
      this.updateStats();
    },
    checkLogo1(obj) {
      return obj.filename === "logo1.png";
    },
    checkLogo2(obj) {
      return obj.filename === "logo2.png";
    },
    onChange(event) {
      this.reset();
      this.page = event.target.value;
      this.updateStats();
    },
    getDates() {
      const date1 = moment(this.dateRange.startDate).startOf("day");
      const date2 = moment(this.dateRange.endDate).endOf("day");
      let curDate = moment(date1);
      const dates = [];

      while (curDate.isBefore(date2)) {
        dates.push(curDate.format("DD MM YYYY"));
        curDate.add(1, "day");
      }
      //console.log(date1.format('DD MMM YYYY'), date2.format('DD MMM YYYY'), "getDates", dates);
      return dates;
    },
    reset() {
      this.articleSelected = false;
      this.dateSelected = false;
    },
    async updateStats() {
      this.loading = true;
      var dates = this.getDates();
      var res = await this.$axios.post("/api/stats/" + this.gameData._id, {
        dateStart: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        dateEnd: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        page: this.page,
        dateSelected: this.dateSelected,
        articleSelected: this.articleSelected,
      });

      this.globalDatas = res.data;
      this.globalDatas.dates = dates;
      console.log(this.globalDatas);
      this.loading = false;
    },
  },
  mounted() {
    this.$axios
      .get("/api/stats/" + this.$route.params._id)
      .then((response) => {
        this.gameData = response.data;

        if (this.gameData.type == "WEB") this.page = 1;
        if (this.gameData.type == "ODR") this.page = 2;
        if (this.gameData.type == "FORMULAIRE") this.page = 3;

        if (this.gameData.files) {
          this.logo1 = this.gameData.files.find(this.checkLogo1);
          this.logo2 = this.gameData.files.find(this.checkLogo2);
        }

        this.minDate = moment(this.gameData.date_debut).format("YYYY-MM-DD");
        this.maxDate = moment(this.gameData.date_fin).format("YYYY-MM-DD");

        this.updateStats();
      })
      .catch((error) => {
        // console.log(error)
        // this.$router.push("/?error");
      });
  },
};
</script>

<style lang="scss">
.stats {
  margin: 0 auto;
  width: 1200px;
  padding: 20px;
  min-height: 500px;
  background-color: white;
  border-radius: 15px;
  margin-top: 20px;
  margin-bottom: 50px;
}

.cell {
  width: 97%;
}

.statistiques {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;

  .lf {
    width: 300px;
    .blue1 {
      background-color: #3949ab;
      color: white;
    }
    .blue2 {
      background-color: #1565c0;
      color: white;
    }
    .blue3 {
      background-color: #1e88e5;
      color: white;
    }
    .blue4 {
      background-color: #64b5f6;
      color: #3949ab;
    }
    .blue5 {
      background-color: #bbdefb;
      color: #3949ab;
    }
  }

  .rd {
    padding: 10px;
    text-align: center;
    width: 880px;

    h1 {
      font-weight: normal;
      font-size: 15px !important;
    }

    .logo {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-bottom: -40px;

      img {
        align-self: center;
        width: 35%;
        margin-top: -80px;
      }
    }
  }

  h2 {
    font-size: 15px;
    margin-bottom: 5px;
  }

  select,
  input {
    height: 40px;
    width: 100%;
    border-radius: 5px;
    border: none;
    background-color: #f2f6f5;
    font-family: "PT Sans", sans-serif !important;
  }
}

.vue-daterange-picker {
  width: 95% !important;

  .reportrange-text {
    width: 100% !important;
  }
}
hr {
  border-top: 5px solid #26a0fc;
}
.daterangepicker {
  min-width: 555px !important;
}
</style>
